import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=5b17618d&scoped=true&"
import script from "./Drawer.vue?vue&type=script&lang=js&"
export * from "./Drawer.vue?vue&type=script&lang=js&"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=5b17618d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b17618d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppNavigation: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/app/Navigation.vue').default,AppControls: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/app/Controls.vue').default})
